import React from "react"

import Container from "@ecom/ui/components/Container"

import clsx from "clsx"
import * as styles from "./advantages.module.scss"
import { ITEMS } from "./items"
import { AdvantagesProps } from "./types"
import { AdvantageCard } from "./AdvantageCard"

export function Advantages({
  data = "DEFAULT_ITEMS",
  orderNum,
  variantStyle,
  headTitle,
}: AdvantagesProps) {
  const items = ITEMS[data]

  return (
    <div data-exclude={orderNum}>
      <Container className={clsx(styles.container, variantStyle && styles[variantStyle])}>
        {headTitle && <h2 className={styles.headTitle}>{headTitle}</h2>}
        <div className={styles.list}>
          {items.map((item, index) => (
            <AdvantageCard
              key={index}
              title={item.title}
              description={"description" in item ? item.description : undefined}
              Icon={item.Icon}
            />
          ))}
        </div>
      </Container>
    </div>
  )
}
